/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalMCPTaskOwnerRequest
 */
export interface InternalMCPTaskOwnerRequest {
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskOwnerRequest
     */
    ownerUserId: string;
    /**
     * 
     * @type {string}
     * @memberof InternalMCPTaskOwnerRequest
     */
    ownerClientId: string;
}

/**
 * Check if a given object implements the InternalMCPTaskOwnerRequest interface.
 */
export function instanceOfInternalMCPTaskOwnerRequest(value: object): value is InternalMCPTaskOwnerRequest {
    if (!('ownerUserId' in value) || value['ownerUserId'] === undefined) return false;
    if (!('ownerClientId' in value) || value['ownerClientId'] === undefined) return false;
    return true;
}

export function InternalMCPTaskOwnerRequestFromJSON(json: any): InternalMCPTaskOwnerRequest {
    return InternalMCPTaskOwnerRequestFromJSONTyped(json, false);
}

export function InternalMCPTaskOwnerRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalMCPTaskOwnerRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'ownerUserId': json['owner_user_id'],
        'ownerClientId': json['owner_client_id'],
    };
}

export function InternalMCPTaskOwnerRequestToJSON(json: any): InternalMCPTaskOwnerRequest {
    return InternalMCPTaskOwnerRequestToJSONTyped(json, false);
}

export function InternalMCPTaskOwnerRequestToJSONTyped(value?: InternalMCPTaskOwnerRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'owner_user_id': value['ownerUserId'],
        'owner_client_id': value['ownerClientId'],
    };
}

